import { AuthPageLayout } from "./AuthPageLayout";
import { LoadingButton } from "./LoadingButton";

/**
 * パスワードリセット開始画面（メールアドレス入力）
 */
export const ForgotPasswordUI: React.FC<{
  loading: boolean;
  error: string | null;
  email: string;
  onEmailChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}> = ({ loading, error, email, onEmailChange, onSubmit, onCancel }) => {
  return (
    <AuthPageLayout>
      {/* タイトル */}
      <h2 className="text-3xl font-bold text-center text-neutral-900 mb-4">
        パスワードをリセット
      </h2>
      <p className="text-center text-neutral-600 mb-8">
        登録されているメールアドレスを入力してください。
        <br />
        パスワードリセット用のコードを送信します。
      </p>

      {/* フォーム */}
      <form onSubmit={onSubmit} className="space-y-6">
        {/* メールアドレス */}
        <div>
          <input
            id="forgot-email"
            type="email"
            placeholder="メールアドレスを入力してください"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            className="w-full px-6 py-4 border border-neutral-300 rounded-2xl text-neutral-900 placeholder-neutral-400 focus:outline-none focus:border-primary transition-colors bg-white"
            disabled={loading}
          />
        </div>

        {/* エラーメッセージ */}
        {error && <div className="text-sm text-red-600">{error}</div>}

        {/* 案内メッセージ */}
        <div className="text-sm text-neutral-600 bg-neutral-50 p-4 rounded-lg">
          メールアドレスが不明な場合や、メールが届かない場合は、システム管理者にお問い合わせください。
        </div>

        {/* ボタン */}
        <div className="space-y-3">
          <LoadingButton loading={loading} loadingMessage="送信中..." label="リセットコードを送信" />

          <button
            type="button"
            onClick={onCancel}
            className="w-full bg-gray-500 hover:bg-gray-600 text-white py-4 rounded-2xl text-xl font-bold transition-colors"
            disabled={loading}
          >
            ログインに戻る
          </button>
        </div>
      </form>
    </AuthPageLayout>
  );
};
